import en, { humanized, remaining } from "./en.js";
import es, { humanized as external_es_js_humanized, remaining as external_es_js_remaining } from "./es.js";
import pt, { humanized as external_pt_js_humanized, remaining as external_pt_js_remaining } from "./pt.js";
const locales_humanized = {
    es: external_es_js_humanized,
    pt: external_pt_js_humanized,
    en: humanized
};
const locales_remaining = {
    es: external_es_js_remaining,
    pt: external_pt_js_remaining,
    en: remaining
};
const locales = {
    es: es,
    pt: pt,
    en: en
};
export default locales;
export { locales_humanized as humanized, locales_remaining as remaining };
